import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCompassSquare: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase
      {...props}
      ariaLabel="compass-square, browser, safari, web, internet, navigation"
    >
      <path
        d="M14.8284 9.17155L10 9.99998L9.17158 14.8284L14 14L14.8284 9.17155Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M4 4H20V20H4V4Z" stroke="currentColor" strokeWidth="2" />
    </CentralIconBase>
  );
};

export default IconCompassSquare;
